import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, SnackbarService } from '../../services';
import { PUBLIC_ROUTES } from '../../structs';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private authService : AuthService, private router : Router, private snackbar : SnackbarService){

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      
      if(this.authService.getToken() && this.authService.getRoles().length>1){
        return true;
      }
      else {
        this.router.navigate([PUBLIC_ROUTES.auth])
        return false;
      }

      

  }
  
}
